<template>
    <div class="sheetSelectModal">
        <dsh-modal
            class="sheetSelectModal-modal"
            v-model="showModal"
            mode="middle"
            :propsObj="modalPropsObj"
        >
            <div class="sheetSelectModal-wrap">
                <!-- 头部 -->
                <div class="sheetSelectModal-header">
                    <!-- 左 -->
                    <dsh-input
                        class="sheetSelectModal-header-left"
                        :value="searchObj"
                        :propsObj="searchPropsObj"
                        @search="search"
                        @change="search"
                    ></dsh-input>

                    <!-- 右 -->
                    <dsh-buttons
                        class="sheetSelectModal-header-right"
                        :list="$getOperationList(['canCreate', 'batchSelect'])"
                        @click="$dispatchEvent($event)"
                    ></dsh-buttons>
                </div>

                <!-- 列表 -->
                <div class="sheetSelectModal-list">
                    <dsh-box
                        ref="box"
                        :data="listData"
                        :columns="selfColumns"
                        :listPropsObj="listPropsObj"
                        pageMode="small"
                        :total="total"
                        :pagePropsObj="pagePropsObj"
                        @clickRow="clickRow"
                        @selectChange="changeSelect"
                        @changePage="changePage"
                    ></dsh-box>

                    <!-- 编辑模态框 -->
                    <dsh-render :render="updateModalRender"></dsh-render>
                </div>
            </div>
        </dsh-modal>
    </div>
</template>

<script>
    import sheetMixin from "@/mixins/sheet/sheetMixin.js";

    export default {
        name: "sheetSelectModal",
        mixins: [sheetMixin],
        props: {
            value: Boolean,

            canEdit: {
                type: Boolean,
                default: true
            },
            propsObj: {
                type: Object,
                default () {
                    return {};
                }
            },
            multiple: {
                type: Boolean,
                default: true
            },
            useCreate: {
                type: Boolean,
                default: true
            },
            defaultSearchParams: Object
        },
        computed: {
            showModal: {
                get () {
                    return this.value;
                },
                set (val) {
                    this.$emit("input", val);
                }
            },
            indexParams () {
                return {
                    search: this.defaultSearchParams,
                    ...this.searchObj
                };
            },
            sortData () {
                return (this.propsObj._sortField || []).concat(["-createdAt"]).join(" ");
            },
            selfColumns () {
                return this.lessColumns.concat(
                    this.operationMap.selectRow
                        ? [this.$createOperationCol(["selectRow"])]
                        : []
                );
            },
            listPropsObj () {
                return {
                    ...this.propsObj,
                    multiple: this.multiple
                };
            },

            selfBtnOperationMap () {
                return {
                    canCreate: {
                        name: `添加${this.modName}`,
                        type: "canCreate",
                        icon: "md-add",
                        btnType: "primary",
                        class: "sheetSelectModal-header-btn",
                        event: "clickCreate"
                    }
                };
            },
            allOperationMap () {
                return {
                    ...this.baseOperationMap,

                    selectRow: {
                        name: "选择",
                        type: "selectRow",
                        btnType: "text",
                        size: "small",
                        event: "selectRow"
                    },
                    batchSelect: {
                        name: "确认选择",
                        type: "batchSelect",
                        btnType: "primary",
                        disabled: !this.selectIds.length,
                        event: "batchSelect"
                    }
                };
            },
            operationMap () {
                let operationMap = this.$categoryMapToMap(this.allOperationMap, null, [
                    ...(this.useCreate ? [] : ["canCreate"]),
                    ...(this.multiple ? ["selectRow"] : ["batchSelect"])
                ]);

                return this.canEdit ? operationMap : [];
            }
        },
        data () {
            return {
                modalPropsObj: {
                    title: "选择数据",
                    width: "960",
                    className: "vertical-center-modal",
                    maskClosable: false,
                    footerHide: true
                },

                searchObj: {
                    fulltextSearch: ""
                },
                searchPropsObj: {
                    _name: "搜索文字",
                    _key: "fulltextSearch",
                    _search: true
                }
            };
        },
        created () {},
        methods: {
            // 拿到表单数据后
            getModAfter () {
                this.search();
            },
            // 回调 -新增
            createCb (data) {
                this.pagePropsObj.page = 1;
                this.reset(() => {
                    this.$nextTick(() => {
                        this.$refs.box.$refs.list.pushSelectIds([data._id]);
                    });
                });
            },

            // 选择该项
            selectRow (operationItem, row) {
                this.$emit("selectRow", row);
                this.showModal = false;
            },
            // 批量选择
            batchSelect (operationItem) {
                if (this.selectIds.length) {
                    this.$emit("batchSelect", this.selectIds, this.selections);
                    this.showModal = false;
                } else {
                    this.$Message.warning("请选择数据!");
                }
            },
            reset (callback) {
                this.checkAll = false;
                this.selections = [];

                this.showBox = false;
                this.getListData(callback);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/menu/sheet/sheetSelectModal.vue